import { DownloadSimple } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { downloadImage } from "@/components/exam/CertificatePanel";

const esc = (v) => {
  const s = v == null ? "" : String(v);
  return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
};

export default function TeacherCsvButton({ data, items, es, className }) {
  const run = () => {
    const head = [
      es ? "Nombre" : "Name", "Email", es ? "Clase" : "Class",
      es ? "Proyectos completados" : "Projects completed",
      es ? "Entregables" : "Deliverables",
      es ? "Insignias" : "Badges",
      es ? "Mejor examen" : "Best exam",
      es ? "Fecha del certificado" : "Certificate date",
      es ? "Racha de práctica" : "Practice streak",
      ...items.map((p) => p.title),
    ];
    const of = (a, b) => `${a} ${es ? "de" : "of"} ${b}`;
    const rows = data.rows.map((r) => [
      r.name, r.email, r.class_name || "",
      of(r.projects_done, items.length),
      of(r.items_done, data.items_total),
      of(r.badges ?? 0, data.badges_total),
      r.best_exam == null ? "" : of(r.best_exam, data.exam_total),
      r.certificate_date ? r.certificate_date.slice(0, 10) : "",
      r.practice_clears || 0,
      ...items.map((p) => of(r.projects[p.id] || 0, data.sizes[p.id] || 0)),
    ]);
    const csv = "\uFEFF" + [head, ...rows].map((row) => row.map(esc).join(",")).join("\r\n");
    const date = new Date().toISOString().slice(0, 10);
    downloadImage(new Blob([csv], { type: "text/csv;charset=utf-8" }), `dslr-advisor-${className ? className.replace(/[^\w-]+/g, "-").toLowerCase() : "all-students"}-${date}.csv`);
  };
  return (
    <Button onClick={run} disabled={!data?.rows?.length} variant="outline" className="border-[#F5A524]/40 text-[#F5A524] hover:bg-[#F5A524]/10" data-testid="teacher-csv-btn">
      <DownloadSimple weight="bold" className="w-4 h-4 mr-1.5" />
      {es ? "Descargar CSV" : "Download CSV"}
    </Button>
  );
}
